import { t } from 'i18next';
import { all, call, delay, takeEvery, put, select } from 'redux-saga/effects';
import { Api } from '../../../../services/config/Api';
import { DATASTORE_ACTIONS } from '../../../commons/DatastoreConstants';
import { dispatchSetApplicationErrorMessage } from '../../../dispatchers/app/ApplicationDispatcher';

const MAX_RETRIES_PER_FILE = 3;
const DELAY_BETWEEN_RETRIES_IN_MS = 100;

const getWorkspaceId = (state) => state.workspace.current?.data?.id;
const getOrganizationId = (state) => state.organization.current?.data?.id;

function* uploadFileWithRetries(organizationId, workspaceId, fileData, override, filePath) {
  let lastError;
  let attempts = 0;
  do {
    try {
      const response = yield call(
        Api.Workspaces.uploadWorkspaceFile,
        organizationId,
        workspaceId,
        fileData,
        override,
        filePath
      );
      return response;
    } catch (attemptError) {
      lastError = attemptError;
      ++attempts;
      yield delay(DELAY_BETWEEN_RETRIES_IN_MS);
    }
  } while (attempts < MAX_RETRIES_PER_FILE);

  throw lastError;
}

/*
Action parameters:
- files: list of objects with these properties:
  - data: File object representing the file content & name
  - path: path of file when uploaded as a workspace file
*/
export function* uploadDatastoreFiles(action) {
  const workspaceId = yield select(getWorkspaceId);
  const organizationId = yield select(getOrganizationId);

  try {
    yield put({ type: DATASTORE_ACTIONS.SET_NETWORK_REQUEST_PENDING, networkRequestPending: true });
    const files = action.files;
    yield all(
      files.map((file) => call(uploadFileWithRetries, organizationId, workspaceId, file.data, true, file.path))
    );
    yield put({
      type: DATASTORE_ACTIONS.ADD_WORKSPACE_FILE_PATHS,
      workspaceFilePaths: files.map((file) => `${file.path}${file.data.name}`),
    });
  } catch (error) {
    console.error(error);
    yield put(
      dispatchSetApplicationErrorMessage(
        error,
        t(
          'commoncomponents.datastore.errors.cannotUploadDatastoreFiles',
          'A problem occurred when uploading datastore workspace files.'
        )
      )
    );
  } finally {
    yield put({ type: DATASTORE_ACTIONS.SET_NETWORK_REQUEST_PENDING, networkRequestPending: false });
  }
}

function* uploadDatastoreFilesSaga() {
  yield takeEvery(DATASTORE_ACTIONS.TRIGGER_SAGA_UPLOAD_DATASTORE_FILES, uploadDatastoreFiles);
}

export default uploadDatastoreFilesSaga;
